import moment from 'moment';
import * as React from 'react';
import {
  List,
  Datagrid,
  Edit,
  Create,
  SimpleForm,
  TextField,
  EditButton,
  TextInput,
  DateField,
  useEditContext,
  required,
  useTranslate,
} from 'react-admin';

import EmptyList from '../components/misc/EmptyList';
import SelectUserByEmailInput from '../components/form/SelectUserByEmailInput';

const entity = 'affiliates';

export const AffiliatesList = (props) => {
  const translate = useTranslate();
  const filters = [
    <TextInput
      key="code"
      source="code"
      alwaysOn
      placeholder="AF Code"
      label={translate('affiliates.search_code', { _: 'AF Kodu Ara' })}
      autoComplete="off"
    />,
  ];

  return (
    <List
      {...props}
      empty={<EmptyList entity={entity} />}
      title={translate('affiliates.title', { _: 'Satış Ortakları (Affiliates)' })}
      filters={filters}
      exporter={false}
    >
      <Datagrid>
        <TextField source="name" label={translate('affiliates.name', { _: 'İsim' })} />
        <TextField source="code" label={translate('affiliates.code', { _: 'Ortaklık Kodu' })} />
        <DateField source="createdate" label={translate('affiliates.created', { _: 'Oluşturulma Tarihi' })} />
        <EditButton />
      </Datagrid>
    </List>
  );
};

export const AffiliatesCreate = (props) => {
  const translate = useTranslate();
  const code = React.useMemo(() => `AF${moment().format('x')}`, []);

  return (
    <Create title={translate('affiliates.new_affiliate', { _: 'Yeni Satış Ortağı' })} {...props} redirect="list">
      <SimpleForm defaultValues={{ id: code, code }} redirect="list">
        <h3>{translate('affiliates.details', { _: 'Satış Ortağı Detayları' })}</h3>
        <TextInput source="name" label={translate('affiliates.name', { _: 'İsim / Şirket Adı' })} fullWidth validate={required()} />
        <TextInput source="code" label={translate('affiliates.code', { _: 'Ortaklık Kodu' })} fullWidth disabled />

        <h3>{translate('promoters.user', { _: 'Kullanıcı' })}</h3>
        <SelectUserByEmailInput source="user" required />
      </SimpleForm>
    </Create>
  );
};

export const AffiliatesEdit = (props) => {
  const translate = useTranslate();
  return (
    <Edit title={translate('affiliates.edit_affiliate', { _: 'Satış Ortağını Düzenle' })} {...props}>
      <SimpleForm redirect={`/${entity}`}>
        <EditForm />
      </SimpleForm>
    </Edit>
  );
};

const EditForm = () => {
  const translate = useTranslate();
  const { record, isLoading } = useEditContext();
  if (isLoading) return null;

  return (
    <React.Fragment>
      <h3>{translate('affiliates.details', { _: 'Satış Ortağı Detayları' })}</h3>
      <TextInput source="name" label={translate('affiliates.name', { _: 'İsim / Şirket Adı' })} fullWidth />
      <TextInput source="code" label={translate('affiliates.code', { _: 'Ortaklık Kodu' })} fullWidth disabled />

      <h3>{translate('promoters.user', { _: 'Kullanıcı' })}</h3>
      <SelectUserByEmailInput source="user" record={record} />
    </React.Fragment>
  );
};
